(function () {
    'use strict';

    angular
        .module('app.reporting')
        .run(appRun);

    appRun.$inject = ['routerHelper'];

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reporting',
                config: {
                    url: '/reporting',
                    title: 'Raporlama',
                    abstract: true,
                    templateUrl: 'app/reporting/reporting.html',
                    settings: {
                        nav: 3,
                        name: 'products',
                        icon: 'fa fa-cubes',
                        content: 'Ürün',
                        resource: 'menu.reporting'
                    }
                }
            },
            {
                state: 'reporting.visitor',
                config: {
                    templateUrl: 'app/reporting/visitorReporting/visitor.reporting.html',
                    controller: 'VisitorReportingController',
                    controllerAs: 'vm',
                    url: '/visitor',
                    title: 'Ziyaretçi Raporları',
                    settings: {
                        nav: 4,
                        name: 'reporting.visitor',
                        topName: 'system',
                        content: 'Diller',
                        resource: 'menu.cultures'
                    }
                }
            }
        ];
    }
})();